// 에러 메시지 변환 함수
export const getFriendlyErrorMessage = (error: any): string => {
  const errorMessage = error?.message || error?.toString() || '알 수 없는 오류가 발생했습니다.';
  
  // 백엔드에서 오는 구체적인 에러 메시지들
  if (errorMessage.includes('소셜 로그인 사용자 등록 실패') || errorMessage.includes('백엔드 인증 실패')) {
    return '서버 연결에 문제가 있습니다. 잠시 후 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('백엔드에서 사용자 정보를 받지 못했습니다')) {
    return '서버에서 사용자 정보를 받지 못했습니다. 잠시 후 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('Kakao SDK가 로드되지 않았습니다')) {
    return '카카오 로그인 서비스를 불러오는 중 문제가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('Google OAuth SDK가 로드되지 않았습니다')) {
    return '구글 로그인 서비스를 불러오는 중 문제가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('Apple Sign In SDK가 로드되지 않았습니다')) {
    return '애플 로그인 서비스를 불러오는 중 문제가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.';
  }
  
  if (errorMessage.includes('계정이 있습니다.')) {
    return errorMessage;
  }

  // 기본 에러 메시지
  return '로그인 중 문제가 발생했습니다. 다시 시도해주세요.';
};
